import api from "../config/api";

export const sendEmailForContactUs = async(FormData) => {
    const res = await api.post(`/order/?flag=sendMailForUser`, FormData)
    return res.data;
}